import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "star",
  "use": "star-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\" id=\"star\">\n  <polygon fill=\"currentColor\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"17.839\" points=\"200 0 261.8 125.727 400 146.012 300.001 243.821 323.602 382 200 316.727 76.4 382 100 243.821 0 146.012 138.2 125.727\" transform=\"translate(51 59)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol